import {useState} from 'react';
import Box from '@mui/material/Box';
import CountrySelect from './CountrySelect';
import CheckboxSelect from './CheckboxSelect';
import { Card, CardContent, CardActions, Button, Grid } from '@mui/material';

const FilterPane = (props) => {
    const [ countryValue, setCountryValue ] = useState(null);
    const [ organisationValue, setOrganisationValue ] = useState([]);
    const [ safetValue, setSafetValue ] = useState([]);
    const [ techValue, setTechValue ] = useState([]);
    const [ providerValue, setProviderValue ] = useState([]);
    const [ stageValue, setStageValue ] = useState([]);
    const [ impactValue, setImpactValue ] = useState([]);
    const [ sdgValue, setSdgValue ] = useState([]);
    const [ outcomeValue, setOutcomeValue ] = useState([]);
    const [ speciesValue, setSpeciesValue ] = useState([]);

    const handleSubmit = (event) => {
        event.preventDefault();

        let filtered = props.projects.filter( p => {
            return (countryValue === null || countryValue.name === p.project_country) &&
            (organisationValue.length === 0 || organisationValue.some(i => p.owner === i.id)) &&
            (providerValue.length === 0 || providerValue.some(i => p.tech_providers.includes(i.id))) &&
            (safetValue.length === 0 || safetValue.some(i => p.safet_theme.includes(i.label))) &&
            (techValue.length === 0 || techValue.some(i => p.technology_types.includes(i.label))) &&
            (stageValue.length === 0 || stageValue.some(i => p.project_stage === i.label)) &&
            (impactValue.length === 0 || impactValue.some(i => p.project_impact === i.label)) &&
            (sdgValue.length === 0 || (p.sdgs !== null && sdgValue.some(i => p.sdgs.includes(Number(i.label.split(' ')[0]))))) &&
            (outcomeValue.length === 0 || (p.outcomes !== null && outcomeValue.some(i => p.outcomes.includes(i.label)))) &&
            (speciesValue.length === 0 || (p.species !== null && speciesValue.some(i => p.species.includes(i.label))))
        });

        props.setFilteredProjects(filtered);
    }

    return (
<Box>
    <h1 style={{display: 'flex',  justifyContent:'center', alignItems:'center'}}>Search the project database</h1>
    <Card sx={{ margin: "auto"}}>
        <CardContent>
            <Grid container columns={{ xs: 1, sm: 2, md: 3, lg: 4 }} component={"form"} id="filterForm" onSubmit={handleSubmit} sx={{ justifyContent:'center', alignItems:'center' }}>
                <Grid size={1}><CountrySelect value={countryValue} setValue={setCountryValue} /></Grid>
                <Grid size={1}><CheckboxSelect options={props.organisations} value={organisationValue} setValue={setOrganisationValue} id={"organisations"} name={"Lead Organisation"}/></Grid>
                <Grid size={1}><CheckboxSelect options={props.techProviders} value={providerValue} setValue={setProviderValue} id={"techProviders"} name={"Technology Provider"}/></Grid>
                <Grid size={1}><CheckboxSelect options={safetOptions} value={safetValue} setValue={setSafetValue} id={"safetTheme"} name={"SAFET Theme"}/></Grid>
                <Grid size={1}><CheckboxSelect options={techOptions} value={techValue} setValue={setTechValue} id={"techTypes"} name={"Technologies Deployed"}/></Grid>
                <Grid size={1}><CheckboxSelect options={outcomeOptions} value={outcomeValue} setValue={setOutcomeValue} id={"projectOutcomes"} name={"Desired Outcomes"}/></Grid>
                <Grid size={1}><CheckboxSelect options={speciesOptions} value={speciesValue} setValue={setSpeciesValue} id={"species"} name={"Species"}/></Grid>
                <Grid size={1}><CheckboxSelect options={stageOptions} value={stageValue} setValue={setStageValue} id={"projectStage"} name={"Project Stage"}/></Grid>
                <Grid size={1}><CheckboxSelect options={impactOptions} value={impactValue} setValue={setImpactValue} id={"projectImpact"} name={"Impact Level"}/></Grid>
                <Grid size={1}><CheckboxSelect options={sdgOptions} value={sdgValue} setValue={setSdgValue} id={"sdgs"} name={"SDGs"}/></Grid>
            </Grid>
        </CardContent>
        <CardActions>
            <Button form="filterForm" type="submit" variant="contained" size="small" sx={{marginLeft: "auto"}}>Filter</Button>
        </CardActions>
    </Card>
</Box>
    );
  };

// TODO: Obtain these options from the database.

const safetOptions = [
    { label: "Fisheries Management" },
    { label: "Fisheries Enforcement" },
    { label: "Fishing Industry (Commercial)" },
    { label: "Small-scale Fishing" },
    { label: "Government Policy" },
    { label: "Water quality monitoring" },
    { label: "Disease and stress early detection" },
    { label: "Predictive analytics / risk forecasting" },
    { label: "Farm management & productivity" },
    { label: "Sustainability and resilience" },
    { label: "Seafood Buyer" },
    { label: "Scientific Research" },
    { label: "Conservation" },
    { label: "Advocacy" },
];

const techOptions = [
    { label: "Electronic Monitoring"},
    { label: "Vessel Tracking"},
    { label: "Drones and Uncrewed Vehicles"},
    { label: "Coastal Radar"},
    { label: "Electronic Logbooks"},
    { label: "Traceability Systems"},
    { label: "Surveillance Systems"},
    { label: "Mapping (GIS) Systems"},
    { label: "Artificial Intelligence"},
    { label: "Machine Learning"},
    { label: "Environmental DNA"},
    { label: "In-situ Sensors"},
    { label: "By-catch Reduction Devices"},
    { label: "Aquaculture technology"},
    { label: "Early warning & monitoring systems"},
    { label: "Decision-support tools"},
    { label: "Electric Vessels"},
];

const stageOptions = [
    { label: "Idea"},
    { label: "Proposal"},
    { label: "Planned"},
    { label: "Funded"},
    { label: "In Progress"},
    { label: "Complete"},
];

const impactOptions = [
    { label: "Unknown"},
    { label: "Estimated"},
    { label: "Partially Measured"},
    { label: "Fully Measured"},
];

const sdgOptions = [
    { label: "1 No Poverty"},
    { label: "2 Zero Hunger"},
    { label: "3 Good Health and Wellbeing"},
    { label: "4 Quality Education"},
    { label: "5 Gender Equality"},
    { label: "6 Clean Water and Sanitation"},
    { label: "7 Affordable and Clean Energy"},
    { label: "8 Decent Work"},
    { label: "9 Industry, Innovation, Infrastructure"},
    { label: "10 Reduced Inequalities"},
    { label: "11 Sustainable Cities"},
    { label: "12 Responsible Consumption"},
    { label: "13 Climate Action"},
    { label: "14 Life Below Water"},
    { label: "15 Life On Land"},
    { label: "16 Peace, Justice, Strong Institutions"},
    { label: "17 Partnerships for the Goals"},
];

const outcomeOptions = [
    { label: "MPA Designation"},
    { label: "Sustainable Fishing"},
    { label: "Certification"},
    { label: "Fisheries Improvement"},
    { label: "Food Security"},
    { label: "Reduced Poverty"},
    { label: "Greater Equality"},
    { label: "Improved Livelihoods"},
    { label: "Safeguard Human Rights"},
    { label: "Climate Mitigation"},
    { label: "Climate Adaptation"},
];

const speciesOptions = [
    { label: "Tuna"},
    { label: "Swordfish"},
    { label: "Squid"},
    { label: "Sharks"},
    { label: "Whales"},
    { label: "Dolphins"},
    { label: "Rays"},
    { label: "Freshwater Finfish"},
    { label: "Tilapia"},
    { label: "Catfish"},
];

export default FilterPane;